import React, { useEffect, useRef } from "react";
import {
  FaUserCircle,
  FaPlane,
  FaHome,
  FaHotel,
  FaAddressBook,
  FaPassport,
  FaGlobe,
  FaInfoCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "../../assets/company-logo/Logo1.png";
import { NavbarLinks } from "./Navbar";
import ThemeToggleForMobile from "../ThemeToggleForMobile";

const ResponsiveMenu = ({ showMenu, setShowMenu }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowMenu]);

  const getIcon = (name) => {
    switch (name) {
      case "Home":
        return <FaHome />;
      case "flights":
        return <FaPlane />;
      case "Itinerary":
        return <FaGlobe />;
      case "Hotels":
        return <FaHotel />;
      case "Visa":
        return <FaPassport />;
      case "Contact Us":
        return <FaAddressBook />;
      case "About Us":
        return <FaInfoCircle />;
      default:
        return <FaUserCircle />;
    }
  };

  return (
    <div
      ref={menuRef}
      className={`${
        showMenu ? "left-0" : "-left-[100%]"
      } fixed bottom-0 top-0 z-20 flex h-screen w-[75%] flex-col justify-between bg-gradient-to-b from-indigo-600 to-indigo-900 dark:from-gray-800 dark:to-gray-900 text-white px-8 pb-6 pt-16 transition-all duration-300 ease-in-out md:hidden rounded-r-xl shadow-lg`}
    >
      <div className="relative flex mb-0">
        <Link to={"/"} onClick={() => window.scrollTo(0, 0)}>
          <img
            src={Logo}
            alt="TripDekhoo Logo"
            className="w-36 absolute -top-6 -left-4 h-auto"
          />
        </Link>
      <div className="absolute right-2">
        <ThemeToggleForMobile />
      </div>
      </div>
      <div className="mt-0">
        <nav>
          <ul className="space-y-6 text-lg font-semibold">
            {NavbarLinks.map((data) => (
              <li
                key={data.link}
                className="flex items-center space-x-4 transform transition-transform duration-300 hover:scale-105"
              >
                <span className="text-2xl">{getIcon(data.name)}</span>
                <Link
                  to={data.link}
                  onClick={() => setShowMenu(false)}
                  className="inline-block"
                >
                  {data.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="footer text-center mt-12 text-sm">
        <h1>
          Made with{" "}
          <span role="img" aria-label="heart">
            ❤
          </span>{" "}
          in India
        </h1>
      </div>
    </div>
  );
};

export default ResponsiveMenu;
